import { IRootStore } from '../store';
import { IRedirectData } from './store';

export function getRedirectData({ infrastructure }: IRootStore): IRedirectData | undefined {
  return infrastructure.redirectData;
}
